import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { holdingApi } from '@/api/holding';

/**
 * KPI consolidés Holding cross-tenant (7 filiales).
 * refetchInterval 30s pour reflet quasi-temps réel des validations/paiements
 * qui déclenchent recomputeKpi côté backend (invoicesService).
 * staleTime 20s : React Query considère la donnée fraîche pendant 20s
 * (évite doubles fetches lors de focus rapides).
 */
export const useHoldingKpis = (periode?: string) =>
  useQuery({
    queryKey: ['holding', 'kpis', periode ?? 'current'],
    queryFn:  () => holdingApi.getKpis(periode),
    staleTime:              20_000,
    refetchInterval:        30_000,
    refetchIntervalInBackground: false,
    refetchOnWindowFocus:   true,
  });

/**
 * Force le recalcul complet des KPI Holding (7 tenants en parallèle) puis
 * invalide le cache pour un affichage immédiat des nouvelles valeurs.
 * Bouton "Recalculer maintenant" du dashboard Holding.
 */
export const useRecomputeHoldingKpis = () => {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (periode?: string) => holdingApi.recomputeKpis(periode),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ['holding', 'kpis'] });
      qc.invalidateQueries({ queryKey: ['finance', 'kpis'] });
    },
  });
};
